import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@saleor/components/Checkbox";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TableHead from "@saleor/components/TableHead";
import { maybe, renderCollection } from "@saleor/misc";
import ProductSku from "@saleor/motherOrders/components/OrderDetailsList/components/ProductSku";
import { StoreOrderDetails_storeOrder } from "@saleor/storeOrders/types/StoreOrderDetails";
import * as React from "react";
import { FormattedMessage } from "react-intl";

interface TableEditProps {
  storeOrder: StoreOrderDetails_storeOrder;
  classes;
  toggleAll;
  checkNotEditable;
  editProductDialog;
  listElements;
  isChecked;
  toggle;
  onChangeQuantity;
}

const TableEdit: React.FC<TableEditProps> = props => {
  const {
    storeOrder,
    classes,
    toggleAll,
    checkNotEditable,
    editProductDialog,
    listElements,
    isChecked,
    toggle,
    onChangeQuantity
  } = props;

  return (
    <Table className={classes.table}>
      <colgroup>
        <col />
        <col className={classes.colEditName} />
        <col className={classes.colQuantity} />
      </colgroup>
      <TableHead
        colSpan={3}
        disabled={checkNotEditable()}
        checkBoxSmallWidth={true}
        items={storeOrder && storeOrder.lines}
        toggleAll={toggleAll}
        selected={listElements.length}
        toolbar={
          <>
            <Button
              id="removeProductBtn"
              color="primary"
              onClick={() => {
                editProductDialog({
                  payload: listElements,
                  type: "REMOVE_PRODUCT"
                });
              }}
            >
              {" "}
              <span className={classes.buttonOrange}>REMOVE</span>
            </Button>
          </>
        }
      >
        {/* <DisplayColumn column="product" displayColumns={settings.columns}> */}
        <TableCellHeader className={classes.colEditName}>
          <span className={classes.colNameLabel}>
            <FormattedMessage
              defaultMessage="Product"
              description="product name"
            />
          </span>
        </TableCellHeader>
        {/* </DisplayColumn>
        <DisplayColumn column="qty" displayColumns={settings.columns}> */}
        <TableCell className={classes.editQty}>
          <FormattedMessage
            defaultMessage="Qty"
            description="ordered product quantity"
          />
        </TableCell>
        {/* </DisplayColumn>
        <DisplayColumn column="status" displayColumns={settings.columns}> */}

        {/* </DisplayColumn> */}
      </TableHead>
      <TableBody>
        {renderCollection(
          storeOrder && storeOrder.lines,
          (orderDetails, index) => {
            const isSelected = orderDetails
              ? isChecked(orderDetails.id)
              : false;
            return (
              <TableRow
                className={classes.tableRow}
                selected={isSelected}
                key={orderDetails ? orderDetails.id : "skeleton"}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    id="orderDetailsCheckbox"
                    disableClickPropagation
                    checked={isSelected}
                    onChange={() => toggle(orderDetails.id)}
                  />
                </TableCell>

                <TableCell
                  className={classes.colEditName}
                  style={{ minWidth: "235px" }}
                >
                  {maybe(() => storeOrder.order) ? (
                    <div style={{ width: "auto" }}>
                      <span className={classes.colNameLabel}>
                        {orderDetails.productName}{" "}
                        {orderDetails.variantName !== "" ||
                        orderDetails.variantName !== undefined
                          ? `(${orderDetails.variantName})`
                          : ""}
                      </span>
                      <ProductSku
                        productSku={maybe(() => orderDetails.variant.sku)}
                      />
                    </div>
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>

                <TableCell className={classes.editQty}>
                  <TextField
                    id="editQtyTxt"
                    className={classes.editQtyInput}
                    name={`qty${index}`}
                    key={index}
                    defaultValue={orderDetails.quantity}
                    InputProps={{
                      readOnly: false,
                      style: {
                        height: "39px"
                      }
                    }}
                    onChange={e =>
                      onChangeQuantity(e.target.value, orderDetails.id)
                    }
                  ></TextField>
                </TableCell>
              </TableRow>
            );
          },
          () => (
            <TableRow>
              <TableCell colSpan={3}>
                <FormattedMessage defaultMessage="No products found" />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </Table>
  );
};

export default TableEdit;
